export default "__VITE_ASSET__lU$Cierj8Oal1NpnwtR8UQ__"